import React from 'react';

import AlignCenterButton from './AlignCenterButton';

export default function installAlignCenterPlugin(config) {
  const { slate } = config.settings;

  slate.buttons.alignCenter = () => (
    <AlignCenterButton />
  );

  return config;
}